//CUSTOM BUILT BY TROY Donations that will be shown 
p31cart.listDonations = [
  { //$10
    "id": 131126461,
    "vid": 32949236695124
  },
  { //$31
    "id": 172833953,
    "vid": 32949238333524
  },
  { //$100
    "id": 172834189,
    "vid": 39401264644180
  }
];